module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kjv4h"))).then(() => parcelRequire('2KbAe'));